<template>
	<div v-if="cardValue" class="wrapper pointer-events-none no-select" :style="position">

		<!-- Slot -->
		<div id="animator" :class="{bounce}">
			<div class="card" ref="card" :class="[type]" :style="outerCss">
				<!-- <img v-if="image" src="@/assets/components/component_bg_land_default.png" class="pointer-events-none"> -->
				<div class="card-body">
					<h6 class="card-text small">{{ slotText('title') }}</h6>
					<!-- <h6 class="card-text small">DRAG ME</h6> -->
				</div>
			</div>
		</div>
	</div>
</template>



<script>
// import Component from '@/components/Component.vue';

export default {
	props: [ "type", "cardValue", "x", "y", "slotWidth", "slotHeight", "zIndex" ],
	components: {},
	data() {
		return {
			show: true,
			dragged: false,
			bounce: false,
			bounceTimeout: null,
			widthRatio: 1,
			heightRatio: 1
		};
	},
	methods: {
		slotText(key) {
			if (this.cardValue) {
				return this.$t(`card_${this.cardValue}_${key}`);
			}
		},
		playBounce() {
			this.bounce = false;
			clearTimeout(this.bounceTimeout);
			setTimeout(() => {
				this.bounce = true;
				this.bounceTimeout = setTimeout(() => {
					this.bounce = false;
				}, 800);
			}, 50);
		},
	},
	computed: {
		position() {
			// return `left: calc(${this.x}*100%); top: calc(${this.y}*100%); transform: translate(-50%, -50%);`;
			// return `left: calc(${this.x}*100%); top: calc(${this.y}*100%); transform: translate(-50%, -50%);`;
			return {
				left: this.x + 'px',
				top: this.y + 'px',
				transform: `translate(-50%, -50%) rotate(4deg)`,
				zIndex: this.zIndex,
			};
		},
		outerCss() {
			let props = {};

			props.width = `${this.slotWidth}vh`;
			if (this.slotHeight)
				props.height = `${this.slotHeight}vh`;

			return props;
		},
	},
	watch: {
		cardValue() {
			this.playBounce();
		}
	}
};
</script>



<style scoped>
	.wrapper {
		position: absolute;
		opacity: 0.75;
	}


	.card {
		border-radius: 0.4em;
		color: white;
		text-align: center;
		padding: 0.2em;
		user-select: none;
		box-shadow: 4px 12px 16px rgba(0, 0, 0, 0.4);

		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;

		transition: all .06s ease-in;
	}

	.card-body {
		/*padding: 0.8em 0.5em;*/
		border: 1px solid white;
		border-radius: calc(0.4em - 0.2em);

		display: flex;
		flex-direction: column;
		justify-content: center;

		hyphens: auto;
		transition: all .06s ease-in;
	}


	.bounce {
		animation: Bounce .6s ease-out;
	}
	@keyframes Bounce {
		0%	{ transform: scale(1.10); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}
</style>
